// 행/카드/그리드 아이템 내부의 인터랙티브 요소(버튼·링크·입력 등) 위에서 난 이벤트인지 판정한다.
// 그런 이벤트는 컨테이너 클릭으로 흡수하지 않아 중첩 컨트롤이 정상 동작한다.
// DataTable/DataGridView 행 활성화(useRowActivation)와 Card 선택적 클릭이 공유한다.
/**
 * c6 인터랙티브 primitive가 **보이는 클릭 대상**에 다는 마커. 네이티브 태그도 ARIA role도
 * 아닌 커스텀 시각 요소(Checkbox의 네모 span 등)는 아래 태그/role 목록으로는 잡히지 않아,
 * 컨테이너 클릭에 흡수돼 "체크 + 행 활성화"가 동시에 일어난다. 그런 요소에 이 속성을 단다.
 */
export const NESTED_INTERACTIVE_ATTR = "data-c6-interactive";

export const NESTED_INTERACTIVE_SELECTOR = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "[role='button']",
  "[role='link']",
  "[role='checkbox']",
  "[role='switch']",
  "[role='radio']",
  "[role='tab']",
  "[role='option']",
  "[role='menuitem']",
  "[role='menuitemcheckbox']",
  "[role='menuitemradio']",
  "[role='slider']",
  "[role='spinbutton']",
  "[contenteditable='true']",
  `[${NESTED_INTERACTIVE_ATTR}]`,
].join(", ");

export function isNestedInteractiveTarget(
  target: EventTarget | null,
  currentTarget: Element,
): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  const interactiveTarget = target.closest(NESTED_INTERACTIVE_SELECTOR);
  return interactiveTarget != null && interactiveTarget !== currentTarget;
}
